import { extendObservable } from 'mobx'
import { intl } from '../locales/config'

import AuthStore from './AuthStore'
import VirtualRoomStore from './VirtualRoomStore'
import DisciplineStore from './DisciplineStore'
import ReportStore from './ReportsStore'
import CourseStore from './CourseStore'
import ForumStore from './ForumStore'
import { themeConfig } from '../Util'
import TrailStore from './TrailStore'

class RoadBarStore {
  constructor () {
    this.initialSubtitle = intl.formatMessage({ id: 'roadBarStore.initialSubtitle', defaultMessage: 'Área Inicial' })
    extendObservable(this, {
      title: '',
      links: [],
      icon: ['', '']
    })
    this.update()
  }

  static stores () {
    return {
      institutions: undefined,
      students: undefined,
      users: undefined,
      'lessons-group': undefined,
      disciplines: DisciplineStore,
      'tutor-room': RoadBarStore.mapVirtualRoomStore(),
      'edit-profile': undefined,
      'student-room': RoadBarStore.mapVirtualRoomStore(),
      reports: ReportStore,
      'client-reports': ReportStore,
      'staff-reports': ReportStore,
      domains: undefined,
      import: undefined,
      courses: CourseStore,
      'questions-database': undefined,
      'generate-links': undefined,
      announcements: undefined,
      'scorm-management': undefined,
      trails: TrailStore
    }
  }

  static titles () {
    return {
      institutions: [intl.formatMessage({ id: 'roadBarStore.institutionManagement', defaultMessage: `Gestão {deInstituicoesC}` }, { deInstituicoesC: themeConfig.terms.deInstituicoesC })],
      students: [intl.formatMessage({ id: 'roadBarStore.studentManagement', defaultMessage: `Gestão de {alunosC}` }, { alunosC: themeConfig.terms.alunosC })],
      users: [intl.formatMessage({ id: 'roadBarStore.userManagement', defaultMessage: `Gestão de Usuários` })],
      'lessons-group': [intl.formatMessage({ id: 'roadBarStore.groupManagement', defaultMessage: `Gestão {deGruposDeAulaICC}` }, { deGruposDeAulaICC: themeConfig.terms.deGruposDeAulaICC })],
      'edit-profile': [intl.formatMessage({ id: 'roadBarStore.profileSettings', defaultMessage: 'Configurações de perfil' })],
      disciplines: [intl.formatMessage({ id: 'roadBarStore.disciplineManagement', defaultMessage: `Gestão {deDisciplinasC} e {turmasC}` }, { deDisciplinasC: themeConfig.terms.deDisciplinasC, turmasC: themeConfig.terms.turmasC }), themeConfig.terms.disciplinaC, intl.formatMessage({ id: 'roadBarStore.tutorsAndStudents', defaultMessage: `{tutoresC} e {alunosC} {daTurmaC}` }, { tutoresC: themeConfig.terms.tutoresC, alunosC: themeConfig.terms.alunosC, daTurmaC: themeConfig.terms.daTurmaC })],
      'tutor-room': [intl.formatMessage({ id: 'roadBarStore.tutorRoom', defaultMessage: `Sala Virtual do {tutorC}` }, { tutorC: themeConfig.terms.tutorC }), themeConfig.terms.grupoDeAulasICC, themeConfig.terms.aulaC],
      'student-room': [intl.formatMessage({ id: 'roadBarStore.studentRoom', defaultMessage: `Sala Virtual {doAlunoC}` }, { doAlunoC: themeConfig.terms.doAlunoC }), themeConfig.terms.grupoDeAulasICC, themeConfig.terms.aulaC],
      'questions-database': [intl.formatMessage({ id: 'roadBarStore.questionsDatabase', defaultMessage: 'Banco de Questões' }), intl.formatMessage({ id: 'roadBarStore.questionsDetails', defaultMessage: 'Detalhes do banco' })],
      reports: [intl.formatMessage({ id: 'roadBarStore.reports', defaultMessage: 'Relatórios' })],
      'client-reports': [intl.formatMessage({ id: 'roadBarStore.reports', defaultMessage: 'Relatórios' })],
      'staff-reports': [intl.formatMessage({ id: 'roadBarStore.reports', defaultMessage: 'Relatórios' })],
      'generate-links': [intl.formatMessage({ id: 'roadBarStore.createLinks', defaultMessage: 'Criação de Links - Magalu' })],
      domains: [intl.formatMessage({ id: 'roadBarStore.domains', defaultMessage: 'Domínios' })],
      import: [intl.formatMessage({ id: 'roadBarStore.batchOperations', defaultMessage: 'Operações em Lote' })],
      courses: [intl.formatMessage({ id: 'roadBarStore.courses', defaultMessage: 'Cursos' })],
      forum: [intl.formatMessage({ id: 'roadBarStore.forum', defaultMessage: 'Fórum' })],
      liveclass: [intl.formatMessage({ id: 'roadBarStore.liveClass', defaultMessage: 'Aula ao vivo' })],
      taskdelivery: [intl.formatMessage({ id: 'roadBarStore.taskDelivery', defaultMessage: `Entrega de {trabalhoC}` }, { trabalhoC: themeConfig.terms.trabalhoC })],
      announcements: [intl.formatMessage({ id: 'roadBarStore.announcements', defaultMessage: 'Comunicados' })],
      'scorm-management': [intl.formatMessage({ id: 'roadBarStore.scormLibrary', defaultMessage: 'Biblioteca SCORM' })],
      trails: [intl.formatMessage({ id: 'roadBarStore.knowledgeTrail', defaultMessage: 'Trilha de Conhecimento' })]
    }
  }

  static subtitles () {
    return {
      institutions: [themeConfig.terms.instituicoesC],
      students: [themeConfig.terms.alunosC],
      users: [intl.formatMessage({ id: 'roadBarStore.users', defaultMessage: 'Usuários' })],
      'lessons-group': [intl.formatMessage({ id: 'roadBarStore.groupManagement', defaultMessage: `Gestão {deGruposDeAulaICC}` }, { deGruposDeAulaICC: themeConfig.terms.deGruposDeAulaICC })],
      'edit-profile': [intl.formatMessage({ id: 'roadBarStore.profileSettings', defaultMessage: 'Configurações de perfil' })],
      disciplines: [themeConfig.terms.disciplinasC, `${themeConfig.terms.turmasC}`, `${themeConfig.terms.tutoresC} ${intl.formatMessage({ id: 'roadBarStore.and', defaultMessage: 'e' })} ${themeConfig.terms.alunosC}`],
      'tutor-room': [themeConfig.terms.disciplinasC, themeConfig.terms.grupoDeAulasICC, themeConfig.terms.aulaC],
      'student-room': [themeConfig.terms.disciplinasC, themeConfig.terms.grupoDeAulasICC, themeConfig.terms.aulaC],
      'questions-database': [intl.formatMessage({ id: 'roadBarStore.questionsDatabase', defaultMessage: 'Banco de Questões' }), intl.formatMessage({ id: 'roadBarStore.questionsDetails', defaultMessage: 'Detalhes' })],
      reports: [intl.formatMessage({ id: 'roadBarStore.reports', defaultMessage: 'Relatórios' })],
      'client-reports': [intl.formatMessage({ id: 'roadBarStore.reports', defaultMessage: 'Relatórios' })],
      'staff-reports': [intl.formatMessage({ id: 'roadBarStore.reports', defaultMessage: 'Relatórios' })],
      domains: [intl.formatMessage({ id: 'roadBarStore.domains', defaultMessage: 'Domínios' })],
      import: [intl.formatMessage({ id: 'roadBarStore.batchOperations', defaultMessage: 'Operações em Lote' })],
      courses: [intl.formatMessage({ id: 'roadBarStore.courses', defaultMessage: 'Cursos' })],
      forum: [intl.formatMessage({ id: 'roadBarStore.forum', defaultMessage: 'Fórum' })],
      'generate-links': [intl.formatMessage({ id: 'roadBarStore.createLinks', defaultMessage: 'Criação de Links - Magalu' })],
      liveclass: [intl.formatMessage({ id: 'roadBarStore.liveClass', defaultMessage: 'Aula ao vivo' })],
      taskdelivery: [intl.formatMessage({ id: 'roadBarStore.taskDelivery', defaultMessage: `Entrega de {trabalhoC}` }, { trabalhoC: themeConfig.terms.trabalhoC })],
      announcements: [intl.formatMessage({ id: 'roadBarStore.announcements', defaultMessage: 'Comunicados' })],
      'scorm-management': [intl.formatMessage({ id: 'roadBarStore.scormLibrary', defaultMessage: 'Biblioteca SCORM' })],
      trails: [intl.formatMessage({ id: 'roadBarStore.knowledgeTrail', defaultMessage: 'Trilha de Conhecimento' })]
    }
  }

  static icons () {
    return {
      institutions: ['color_bg_institution', 'fas fa-building'],
      students: ['color_bg_manager', 'fas fa-users'],
      users: ['color_bg_manager', 'fas fa-id-card'],
      disciplines: ['color_bg_manager', 'fas fa-clipboard-list'],
      'tutor-room': ['color_bg_teacher', 'fas fa-graduation-cap'],
      'edit-profile': ['color_bg_publisher', 'fas fa-cog'],
      'student-room': ['color_bg_learn', 'fas fa-user'],
      reports: ['color_bg_manager', 'fas fa-id-card'],
      'client-reports': ['color_bg_manager', 'fas fa-id-card'],
      'staff-reports': ['color_bg_institution', 'fas fa-id-card'],
      domains: ['color_bg_manager', 'fas fa-building'],
      import: ['color_bg_manager', 'fas fa-users'],
      courses: ['color_bg_manager', 'fas fa-clipboard-list'],
      trails: ['color_bg_manager', 'fas fa-book-open'],
      forum: ['color_bg_manager', 'fas fa-clipboard-list'],
      liveclass: ['color_bg_manager', 'fas fa-clipboard-list'],
      taskdelivery: ['color_bg_manager', 'fas fa-clipboard-list'],
      'questions-database': ['color_bg_manager', 'fas fa-list-alt'],
      'generate-links': ['color_bg_manager', 'fas fa-id-card'],
      'lessons-group': ['color_bg_manager', 'fas fa-clone'],
      announcements: ['color_bg_manager', 'fas fa-bell'],
      'scorm-management': ['color_bg_manager', 'fas fa-file-archive']
    }
  }

  // VirtualRoom é uma área que possui mais de uma Store.
  static mapVirtualRoomStore () {
    const pathList = window.location.pathname.split('/').filter(x => x)
    if (pathList.length === 1) return VirtualRoomStore
    if (pathList[1] === 'forum') return ForumStore
    return VirtualRoomStore
  }

  update () {
    const pathList = window.location.pathname.split('/').filter(x => x)
    if (pathList.length > 0 && !(pathList[0] in RoadBarStore.stores())) return
    const store = pathList.length > 0 ? RoadBarStore.stores()[pathList[0]] : null

    if (store) {
      this.title = store.getTitle()
      this.links = store.getLinks(this.links || [])
    } else {
      let address
      const links = []
      for (let i = 0; i < pathList.length; i++) {
        if (i === pathList.length - 1 || !this.links[i]) {
          address = `/${pathList.slice(0, i + 1).join('/')}/${window.location.search}`
          links.push({ title: this.getSubtitle(pathList[0], i), address })
        } else {
          links.push(this.links[i])
        }
      }
      this.title = this.getTitle(pathList[0], pathList.length - 1)
      this.links = links
    }
    this.icon = this.getIcon(pathList[0], pathList.length - 1)
  }

  getTitle (area, index) {
    if (index === -1 && AuthStore && AuthStore.user) {
      return intl.formatMessage({ id: 'roadBarStore.welcomeWithName', defaultMessage: 'Bem-vindo, {name}!' }, { name: AuthStore.user.name })
    }
    if (index === -1) {
      return intl.formatMessage({ id: 'roadBarStore.welcome', defaultMessage: 'Bem-vindo!' })
    }
    return RoadBarStore.titles()[area][index]
  }

  getSubtitle (area, index) {
    return RoadBarStore.subtitles()[area][index]
  }

  getIcon (area, index) {
    if (index === -1) {
      return ['', 'fa fa-lg fa-th']
    } else {
      return RoadBarStore.icons()[area]
    }
  }
}

export default new RoadBarStore()
